import { render, staticRenderFns } from "./tabDialog.vue?vue&type=template&id=53464efe&scoped=true&"
import script from "./tabDialog.vue?vue&type=script&lang=js&"
export * from "./tabDialog.vue?vue&type=script&lang=js&"
import style0 from "./tabDialog.vue?vue&type=style&index=0&id=53464efe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53464efe",
  null
  
)

export default component.exports